import { InjectionToken } from '@angular/core';

/**
 * DI token for the KB API origin — **includes** the `/v1` segment today
 * (e.g. `https://kbapi-dev.kirigami.ai/v1`). The KB adapter appends
 * path fragments like `/kbx/kbs/` or `/kbx/kb/get/:id` onto this origin.
 *
 * Why a dedicated token: the KB API lives on a different subdomain than
 * the Registry API (`kbapi-*` vs `api-*`), so it needs its own origin
 * separate from `REGISTRY_API_BASE_URL`.
 */
export const KB_API_BASE_URL = new InjectionToken<string>('https://kbapi-dev.kirigami.ai/v1');
